import React, { useEffect } from 'react';
import jwt_decode from 'jwt-decode';
import { app } from '@microsoft/teams-js';
import { useSearchParams } from 'react-router-dom';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as RewardsAndRecognitionIllustration } from 'assets/images/rewards-and-recognitions.svg';
import { ReactComponent as RecoginzeIllustration } from 'assets/images/recognize-someone.svg';
import { ReactComponent as RedeemIllustration } from 'assets/images/redeem-in-web.svg';
import { ReactComponent as BonusIllustration } from 'assets/images/award-bonus-icon.svg';
import { useCommonContext } from 'context';
import './style.scss';

const ewWebUrl = process.env.REACT_APP_WEB_URL;

const Index = () => {
    const { darkTheme } = useCommonContext();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const isAdmin = searchParams.get('isAdmin')=== 'true';
    const navigate = useNavigate();
    const recognitionSetupDone = searchParams.get('recognitionSetupDone')=== 'true';

    
    const setupRewardText = isAdmin
        ? 'Please set up Payments and country for points conversion. Clicking on setup will take you to dashboard.'
        : 'Please contact your admin to set up Rewards and Recognitions.';

    useEffect(() => {
        const decodedToken = jwt_decode(token);
        if (!decodedToken?.isActive) {
            navigate('/modals/inactive');
        }
    }, []);

    return (
        <div className={clsx({ 'choose-action': true, 'dark-choose-action': darkTheme })}>
            <div className='choose-action-heading-container'>
                <div className='headline-3 font-size-16 text-center'>Welcome to EngageWith</div>
                <div className='body-3 font-size-12 text-center'>
                    Send out candid recognitions to your teammates and redeem rewards!
                </div>
            </div>

            <div className='whats-on-mind'>
                <div className='headline-3'>What's on your mind today?</div>
                <div className='option-card-container'>
                    {recognitionSetupDone  && (
                        <div
                            className='option-container'
                            onClick={() => navigate('/modals/recognize', { state: { token, isTab: true } })}
                        >
                            <RecoginzeIllustration />
                            <div>
                                <div className='headline-1'>Recognize Someone</div>
                                <div className='body-3'>Extra efforts should always be acknowledged!</div>
                            </div>
                        </div>
                    )}
                    <div
                        className='option-container'
                        onClick={() =>
                            app.openLink(`${ewWebUrl}dashboard/redemptions/redeem/list/?success=true&token=${token}`)
                        }
                    >
                        <RedeemIllustration />
                        <div>
                            <div className='headline-1'>
                                Redeem <span>(View in web)</span>
                            </div>
                            <div className='body-3'>Cha-Ching$ Let's cash in those points</div>
                        </div>
                    </div>
                    {isAdmin && (
                        <div
                            className='option-container'
                            onClick={() =>
                                navigate('/modals/bonus', {
                                    state: { token, isTab: true },
                                })
                            }
                        >
                            <BonusIllustration />
                            <div>
                                <div className='headline-1'>Award a bonus</div>
                                <div className='body-3'>Award your employees on special occasions</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {!recognitionSetupDone  && (
                <div className='setup-reward-container'>
                    <RewardsAndRecognitionIllustration />
                    <div>
                        <div className='subtitle-4'>Rewards and Recognition</div>
                        <div className='body-3'>{setupRewardText}</div>
                        {isAdmin && (
                            <button
                                onClick={() =>
                                    app.openLink(`${ewWebUrl}dashboard/global-settings/?success=true&token=${token}`)
                                }
                            >
                                Setup
                            </button>
                        )}
                    </div>
                </div>
            )}
            {isAdmin  && (
                <div className='text-center margin-top-16'>
                    <a onClick={() => app.openLink(`${ewWebUrl}dashboard/global-settings/?success=true&token=${token}`)}>
                        Go to settings (view in web)
                    </a>
                </div>
            )}
        </div>
    );
};

export default Index;
